import * as React from 'react'
import {
  Typography,
  Card,
  CardContent,
  CardActionArea,
} from '@material-ui/core'

const Resource = ({ children: resource, onClick, style }) => {
  return (
    <Card style={{ ...style }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography variant="body2">{resource.name}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default Resource
